import * as React from 'react'
import { NavLink, NavLanguage } from 'DVWebNodeUtils'

interface NavLanguageWithURL extends NavLanguage {
  url?: string
}

export interface LocaleSelectorProps {
  text: string,
  locales: NavLink[],
  languages: NavLanguageWithURL[],
  languageToken: string,
  removeIcon?: boolean
}

interface NavLanguageProps {
  isHighlighted: boolean,
  label: string,
  locale: string,
  languageToken: string,
  url: string
}

const LinkWithIcon = ({href, rel, isHighlighted, text} : NavLink) => (
  <a href={href}
    rel={rel}
    className={isHighlighted ? 'pv-highlighted pv-ticked' : ''}>
    {text}
  </a>
)

const LinkWithIconPost = ({label, locale, isHighlighted, languageToken, url} : NavLanguageProps) => (
  <form action={url} method="POST">
    <input type="hidden" name="token" value={languageToken}/>
    <input type="hidden" name="language" value={locale}/>
    <input type="hidden" name="persistLanguage" value="1"/>
    <input type="submit" value={label} className={isHighlighted ? 'pv-highlighted pv-ticked' : ''}/>
  </form>
)

export const listItemsWithIcon = ({languages, locales, languageToken}: LocaleSelectorProps) => {
  if (languages.length > 0) {
    return languages.map((languagesProps, i) => (
      <li key={`${i}-${languagesProps.locale}`} role="menuitem">
        <LinkWithIconPost
          isHighlighted={languagesProps.isHighlighted}
          label={languagesProps.label}
          locale={languagesProps.locale}
          languageToken={languageToken}
          url={languagesProps.url}
        />
      </li>
    ))
  } else {
    return locales.map((localesProps, i) => (
      <li key={`${i}-${localesProps.text}`} role="menuitem">
        <LinkWithIcon {...localesProps} />
      </li>
    ))
  }
}

export const LocaleSelectionSubMenu = (localeSelector: LocaleSelectorProps) => (
  <li className={`pv-subnav-locales ${localeSelector.removeIcon ? 'pv-subnav-no-icon': ''}`}>
    <input type="checkbox"
      id="pv-subnav-locales-menu-trigger" className="pv-subnav-locales-toggle avu-screen-reader-only" name="menu"/>
    <label htmlFor="pv-subnav-locales-menu-trigger"
      className="pv-subnav-locales-menu-label">{localeSelector.text}</label>
    <ul role="menu" aria-label="submenu" className="pv-subnav-locales-dropdown">
      {listItemsWithIcon(localeSelector)}
    </ul>
  </li>
)

export const LocaleSelectorModalContent = (localeSelector: LocaleSelectorProps) => (<ul role="menu">
      <ol className="dv-col" role="menu">
        {listItemsWithIcon(localeSelector)}
      </ol>
    </ul>
)
export const LocaleSelector = (localeSelector: LocaleSelectorProps) => (
  <div className="pv-nav-locales pv-nav-dropl"
  id="pv-nav-locales">
    <input type="checkbox" autoComplete="off" name="pv-nav-locales" id="pv-nav-locales-menu-trigger"
      className="pv-nav-dropl__input avu-screen-reader-only" />
    <label htmlFor="pv-nav-locales-menu-trigger" className="pv-nav-dropl__label">
      <span className="pv-nav-locales-icon">{localeSelector.text}</span>
    </label>
    <ul role="menu">
      <ol className="dv-col" role="menu">
        {listItemsWithIcon(localeSelector)}
      </ol>
    </ul>
  </div>
)
